// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"188": "85310b70af4d5a13","830": "76b0767f0274805a",}[chunkId] + ".js"
}